import { Wallpaper } from '@wetransfer/transfer/store/customWallpapers';

import {
  ClearCustomWallpaperAction,
  SetCustomWallpaperAction,
  SetIsCustomWallpaperBeingFetchedAction,
} from './types';

export enum CustomWallpaperActionType {
  setCustomWallpaper = 'SET_CUSTOM_WALLPAPER',
  clearCustomWallpaper = 'CLEAR_CUSTOM_WALLPAPER',
  setIsCustomWallpaperBeingFetched = 'SET_IS_CUSTOM_WALLPAPER_BEING_FETCHED',
}

export const setCustomWallpaper = (
  wallpaper: Wallpaper
): SetCustomWallpaperAction => ({
  type: CustomWallpaperActionType.setCustomWallpaper,
  payload: wallpaper,
});

export const setIsCustomWallpaperBeingFetched = (
  isBeingFetched: boolean
): SetIsCustomWallpaperBeingFetchedAction => ({
  type: CustomWallpaperActionType.setIsCustomWallpaperBeingFetched,
  payload: isBeingFetched,
});

export const clearCustomWallpaper = (): ClearCustomWallpaperAction => ({
  type: CustomWallpaperActionType.clearCustomWallpaper,
});
